/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingDataFixResultDto } from '../models/HousingDataFixResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingDataFixService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Dry run: reports every inconsistency without writing.
     * @returns HousingDataFixResultDto OK
     * @throws ApiError
     */
    public previewFixes(): CancelablePromise<HousingDataFixResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingDataFix/PreviewFixes',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Applies the fixes reported by the preview endpoint.
     * @returns HousingDataFixResultDto OK
     * @throws ApiError
     */
    public runFixes(): CancelablePromise<HousingDataFixResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingDataFix/RunFixes',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
